// extracted by mini-css-extract-plugin
module.exports = {"form":"styles_form__2UCa2","row":"styles_row__3AWvl"};